<div class="gender-type-setting-form">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>

    <form [formGroup]="form" class="canton-form">
      <mat-form-field>
        <input  matInput placeholder="{{'canton.name' | translate}}" formControlName="name">
      </mat-form-field>
      <div><mat-checkbox formControlName="enable">{{'targetGroup.active' | translate}}</mat-checkbox></div>
      <div><mat-checkbox formControlName="onlyForAdult">{{'onlyForAdult' | translate}}</mat-checkbox></div>
      <div style="margin-top: 10px">
        <mat-radio-group class="radio-group" formControlName="age">
          <mat-radio-button [value]="'child'">
            <div class="radio-buttons">
              <span style="width: 150px;">{{'is_child' | translate}}</span>
              <mat-icon matTooltip="{{'is_child_example' | translate}}" matTooltipPosition="right">info</mat-icon>
            </div>
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" [value]="'adult'">
            <div class="radio-buttons">
              <span style="width: 150px;">{{'is_adult' | translate}}</span>
              <mat-icon matTooltip="{{'is_adult_example' | translate}}" matTooltipPosition="right">info</mat-icon>
            </div>
          </mat-radio-button>
          <mat-radio-button class="radio-buttons" [value]="'other'">
            <div class="radio-buttons">
              <span style="width: 150px;">{{'other' | translate}}</span>
              <mat-icon matTooltip="{{'is_other_example' | translate}}" matTooltipPosition="right">info</mat-icon>
            </div>
          </mat-radio-button>
        </mat-radio-group>
        <!--          <mat-checkbox formControlName="isChild">{{'is_child' | translate}}</mat-checkbox>-->
      </div>
      <div class="def_user_msg">{{'def_user_msg' | translate}}</div>
      <mat-form-field style="margin-top: 15px">
        <mat-select placeholder="{{'default_type' | translate}}" formControlName="defaultType">
          @for (dt of defaultTypes; track dt) {
            <mat-option [value]="dt">
              {{dt | translate}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>

  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    @if (action !=='edit') {
      <button
        mat-raised-button
        (click)="save()"
        class="save-button mat-accent"
        [disabled]="form.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-raised-button
        (click)="save()"
        class="save-button mat-accent"
        [disabled]="form.invalid"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-button
        class="mat-icon-button"
        (click)="delete()"
        aria-label="Delete"
        matTooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
    }

  </div>
</div>
